import './LandingPage.css';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

function LandingPage() {
    const history = useHistory();

    useEffect(() => {
        // Redirect to /login after 5 seconds
        const timer = setTimeout(() => {
            history.push('/login');
        }, 3000);

        return () => clearTimeout(timer);
    }, [history]);
    return <div id='landingPage' />
}

export default LandingPage